module.exports = {
  PASSWORD_POLICY_REG: /^((?=.*[a-z])(?=.*[A-Z])|(?=.*[a-z])(?=.*[0-9])|(?=.*[a-z])(?=.*[!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~])|(?=.*[A-Z])(?=.*[0-9])|(?=.*[A-Z])(?=.*[!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~])|(?=.*[0-9])(?=.*[!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]))([a-zA-Z0-9!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]){8,}$/
};
